import React, { useState, useRef, useEffect } from "react";
import CodeExecutor from "../../../../components/CodeExecutor/CodeExecutor.js";
import {
  Card,
  Row,
  Col,
  CardHeader,
  CardBody,
  CardTitle,
  CardText,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  FormGroup,
  Label,
  Input,
  CardFooter,
  Container
} from "reactstrap";
import LessonNavBar from "components/Navbars/LessonNavBar.js";
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import { CheckCode } from "./CheckCode.js";
import MainFooter from "../../../../components/Footers/MainFooter.js";

import classnames from "classnames";
import { useLesson } from "../../../../hooks/lessonFramework.js";
import { useUserAuth } from "../../../../context/UserContext.js";
import NavigationButton from "../../../../components/NavigationButton/NavigationButton.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChalkboardUser, faSquareCheck, faRobot } from "@fortawesome/free-solid-svg-icons";

import { CODESNIPPET } from "../../../../constants/codeSnippet.js";
import Highlight, { defaultProps } from "prism-react-renderer";
import github from "prism-react-renderer/themes/github";
import AIAssistant from "pages/AI/AIAssistant.js";

const CommentsComponent = () => {
  const lessonID = "JA101";
  const { setInitialCode } = useLesson();
  const mainRef = useRef(null);
  const { user } = useUserAuth();
  const [activeTab, setActiveTab] = useState("1");
  const [lessonCode, setLessonCode] = useState(`public class Main {
  public static void main(String[] args) {

    System.out.println("Hello, Java!");

    System.out.println("This will be printed.");

    System.out.println("This should not be printed.");
  }
}`);

  const executeTests = (code, output) => {
    const newCheckedStates = CheckCode(code, output, checkedStates, user, lessonID);
    updateCheckboxState(newCheckedStates);
  };

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  // CHECKBOXS
  const [checkedStates, setCheckedStates] = useState({
    checkbox1: false,
    checkbox2: false,
    checkbox3: false,
    checkbox4: true,
  });

  // Function to update the state of specific checkboxes
  const updateCheckboxState = (updates) => {
    setCheckedStates((prevState) => ({
      ...prevState,
      ...updates, // Merge the updates into the current state
    }));
  };
  // CHECKBOXS



  return (
    <>
      <div className=" lessonBackgroundColor1 lessonMain  h-100vh" >
        <LessonNavBar />
        <main id="main" tabIndex={-1} className="lessonMain flex-grow-1">
          <section>
            <Container fluid className=" pr-0 pl-0   fullWitdthHeight ">
              <CodeExecutor languageCode="java" initialCode={lessonCode} runTestCase={executeTests}>
                <Card className="fullWitdthHeight">
                  <CardHeader className=" lesson-header">Comments</CardHeader>
                  <TabContent className="fullWitdthHeight overflow-auto " activeTab={activeTab}>
                    <TabPane className="fullWitdthHeight" tabId="1">
                      <CardBody>
                        <CardTitle tag="h5">
                          What Are Comments?
                        </CardTitle>
                        <CardText>
                          {'Comments are lines of text in a program that are ignored by the computer when the code runs. '}
                        </CardText>
                        <CardTitle tag="h5">Types of Comments in Java</CardTitle>
                        <CardText>
                          {'Comments in Java come in two main types: single-line and multi-line. Each serves specific purposes depending on how much information you want to include.'}
                        </CardText>
                        <CardTitle tag="h5">Single-line Comments</CardTitle>
                        <CardText>
                          {'Single-line comments start with // and apply to the rest of the line. These are ideal for short explanations or quick notes about specific lines of code.'}
                        </CardText>
                        <CardText>
                          Example:
                        </CardText>
                        <CardText>
                          <Highlight {...defaultProps} theme={github} code={CODESNIPPET.CommentsCode1} language="java">
                            {({ style, tokens, getLineProps, getTokenProps }) => (
                              <pre style={{ ...style, padding: "15px", borderRadius: "5px", overflowX: "auto" }}>
                                {tokens.map((line, i) => (
                                  <div key={i} {...getLineProps({ line, key: i })}>
                                    {line.map((token, key) => (
                                      <span key={key} {...getTokenProps({ token, key })} />
                                    ))}
                                  </div>
                                ))}
                              </pre>
                            )}
                          </Highlight>
                        </CardText>
                        <CardText>
                          {'In this example, everything after // is ignored by Java.'}
                        </CardText>
                        <CardTitle tag="h5">Multi-line Comments</CardTitle>
                        <CardText>
                          {'Multi-line comments start with /* and end with */. These are useful for adding detailed explanations or documenting larger sections of code.'}
                        </CardText>
                        <CardText>
                          Example:
                        </CardText>
                        <CardText>
                          <Highlight {...defaultProps} theme={github} code={CODESNIPPET.CommentsCode2} language="java">
                            {({ style, tokens, getLineProps, getTokenProps }) => (
                              <pre style={{ ...style, padding: "15px", borderRadius: "5px", overflowX: "auto" }}>
                                {tokens.map((line, i) => (
                                  <div key={i} {...getLineProps({ line, key: i })}>
                                    {line.map((token, key) => (
                                      <span key={key} {...getTokenProps({ token, key })} />
                                    ))}
                                  </div>
                                ))}
                              </pre>
                            )}
                          </Highlight>
                        </CardText>
                        <CardText>
                          {'In this example, everything between /* and */ is treated as a comment and skipped by the computer.'}
                        </CardText>
                      </CardBody>
                    </TabPane>

                    <TabPane tabId="2">
                      <CardBody>
                        {/* CHECKBOXS */}
                        <h4>Try It Yourself</h4>
                        <div className="checkBoxSeparator">
                          <FormGroup check>
                            <Label check>
                              <Input
                                type="checkbox"
                                name="checkbox1"
                                checked={checkedStates.checkbox1}
                                readOnly
                              />
                              Problem 1
                            </Label>
                          </FormGroup>
                        </div>
                        <div className="checkBoxSeparator">
                          <FormGroup check>
                            <Label check>
                              <Input
                                type="checkbox"
                                name="checkbox2"
                                checked={checkedStates.checkbox2}
                                readOnly
                              />
                              Problem 2
                            </Label>
                          </FormGroup>
                        </div>
                        <div className="checkBoxSeparator">
                          <FormGroup check>
                            <Label check>
                              <Input
                                type="checkbox"
                                name="checkbox3"
                                checked={checkedStates.checkbox3}
                                readOnly
                              />
                              Problem 3
                            </Label>
                          </FormGroup>
                        </div>

                        {/* CHECKBOXS */}
                      </CardBody>
                    </TabPane>
                    <TabPane tabId="3">
                      <CardBody>
                        <AIAssistant></AIAssistant>
                      </CardBody>
                    </TabPane>
                  </TabContent>
                  <CardFooter className=" lesson-footer">
                    <Nav tabs className="justify-content-center my-nav-tabs ">
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === "1" })}
                          onClick={() => toggle("1")}
                        >
                          <FontAwesomeIcon icon={faChalkboardUser} size="lg" />
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === "2" })}
                          onClick={() => toggle("2")}
                        >
                          <FontAwesomeIcon icon={faSquareCheck} size="lg" />
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === "3" })}
                          onClick={() => toggle("3")}
                        >
                          <FontAwesomeIcon icon={faRobot} size="lg" />
                        </NavLink>
                      </NavItem>
                    </Nav>
                  </CardFooter>
                </Card>
              </CodeExecutor>
            </Container>
          </section>
          <section >
            <Container className="container-lg">
              <Row className=" p-3   align-items-center  justify-content-between">
                <NavigationButton direction="back" page="printStatements"></NavigationButton>
                <NavigationButton direction="next" page="indentation"></NavigationButton>
              </Row>
            </Container>
          </section>
        </main>
      </div>
    </>
  );
};

export default CommentsComponent;
